import { render } from "./LeadJSONSender.vue?vue&type=template&id=935271b4&scoped=true"
import script from "./LeadJSONSender.vue?vue&type=script&lang=js"
export * from "./LeadJSONSender.vue?vue&type=script&lang=js"

import "./LeadJSONSender.vue?vue&type=style&index=0&id=935271b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-935271b4"]])

export default __exports__